import React from 'react';
import styled from 'styled-components';
import {
  ScanOutlined,
  SearchOutlined,
  StockOutlined,
  TableOutlined,
  DeleteFilled,
  PlusCircleOutlined
} from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import {
  Row,
  Col,
  Spin,
  Button,
  List,
  Tabs,
  Popover,
  Input,
  Table,
  Divider,
  Modal,
  Select,
  Card,
  InputNumber,
  Typography,
  Switch,
  AutoComplete,
  Badge,
  DatePicker
} from 'antd';
import moment from 'moment';
import { Link } from 'react-router-dom';
import Notify from 'src/components/meta/Notification';
import noImage from 'src/static/icons/carImageUpload/no-image-available.svg';
import Countdown from 'react-countdown-now';
import Highlighter from 'react-highlight-words';
import pdfMake from 'pdfmake/build/pdfmake';
import vfsFonts from 'pdfmake/build/vfs_fonts';
import prepDefinition from 'src/components/meta/PdfDefinition2';
import prepDefinition2 from 'src/components/meta/PdfDefinition3';
import ReactExport from 'react-export-excel';
import * as XLSX from 'xlsx';
import { downloadExcel } from 'react-export-table-to-excel';
import { Excel } from 'antd-table-saveas-excel';
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const dataSet1 = [
  {
    serial: 'Johson',
    amount: 30000,
    sex: 'M',
    is_married: true
  },
  {
    name: 'Monika',
    amount: 355000,
    sex: 'F',
    is_married: false
  },
  {
    name: 'John',
    amount: 250000,
    sex: 'M',
    is_married: false
  },
  {
    name: 'Josef',
    amount: 450500,
    sex: 'M',
    is_married: true
  }
];

var dataSet2 = [
  {
    name: 'Johnson',
    total: 25,
    remainig: 16
  },
  {
    name: 'Josef',
    total: 25,
    remainig: 7
  }
];

const { Column, ColumnGroup } = Table;
const { TextArea } = Input;
const FormItem = Form.Item;
const Option = Select.Option;
const { Text } = Typography;
const numeral = require('numeral');
const { TabPane } = Tabs;
const onChange = (date, dateString) => {
  console.log(date, dateString);
};
const { RangePicker } = DatePicker;
const dateFormat = 'YYYY/MM/DD';
const hammer = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6475 17.3418H1.65195C0.740018 17.3418 0 18.0817 0 18.9938V21.9977H14.2994V18.9938C14.2994 18.0817 13.5595 17.3418 12.6475 17.3418Z"
      fill="#AD5E00"
    />
    <path
      d="M21.7036 17.5744L11.6665 7.53725L13.6051 5.60203C13.9248 5.88391 14.4163 5.87013 14.7188 5.56766C15.0351 5.248 15.0351 4.7358 14.7188 4.41614L10.539 0.239743C10.2228 -0.0799143 9.70715 -0.0799143 9.39094 0.239743C9.07128 0.555998 9.07128 1.0716 9.39094 1.38781L9.35657 1.35344L4.04924 6.65728L4.08361 6.69505C3.76736 6.37539 3.25175 6.37539 2.93554 6.69505C2.61589 7.01131 2.61589 7.52691 2.93554 7.84317L7.11194 12.023C7.4316 12.3392 7.9472 12.3392 8.26346 12.023C8.57971 11.7033 8.57971 11.1912 8.26346 10.8715L8.29783 10.9058L10.2365 8.9706L20.2702 19.0043C20.6655 19.3996 21.3083 19.3996 21.7036 19.0043C22.0989 18.609 22.0989 17.9697 21.7036 17.5744Z"
      fill="#AD5E00"
    />
  </svg>
);
const StyledSelect = styled(Select)`
  .ant-select-selector {
    width: 100%;
    height: 55px !important;
    border-radius: 0.5em !important;
    padding-top: 11px !important;
  }
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    position: relative;
    color: red !important;
    background-color: #ffffff;
    border: 1px solid #e9e9e9;
    border-radius: 2px;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  }
  .ant-select-selection-placeholder {
    color: rgba(0, 0, 0, 0.45) !important;
  }
  .ant-select-show-search.ant-select:not(.ant-select-customize-input)
    .ant-select-selector
    input {
    cursor: auto;
    padding-top: 1.2em !important;
  }
`;
const StyledDatePicker = styled(RangePicker)`

  padding-left: 1.2em !important;
  height: 45px !important;

    box-shadow:none !important;
  background-color: white!important;
  background-imquantity: none;
  border: none;
  border: 0px solid black !important;
  border: 1px solid lightgrey !important;
  border-radius: 0px;
  color: black!important;
  //box-shadow: rgba(0, 0, 0, 0.11) 2px 8px 13px 5px !important;
  
  :placeholder {
    color: lightgrey !important;
  }
  :hover {
    border-color: red !important;

    box-shadow:none !important;
}
  :active{
    border-color: red !important;
   
     box-shadow:none !important;
   
  }
  :focus{
    border-color: red !important;
    
     box-shadow:none !important;
   
  }
  }
`;
const StyledTable = styled(Table)`
  .ant-table-thead > tr > th {
    color: #8898aa;
    background: #eef5ff !important;
  }
  .ant-table-tbody > tr > td {
    border-bottom: 1px solid #f0f0f0;
    transition: background 0.3s;

    font-weight: 500;
    color: #525f7f;
    font-size: 15px;
  }
`;
const StyledTabs = styled(Tabs)`
  .ant-tabs-top > .ant-tabs-nav::before,
  .ant-tabs-bottom > .ant-tabs-nav::before,
  .ant-tabs-top > div > .ant-tabs-nav::before,
  .ant-tabs-bottom > div > .ant-tabs-nav::before {
    position: absolute;
    right: 0;
    left: 0;
    border-bottom: 0px solid #f0f0f0 !important;
    content: '';
  }
`;
const Selection = styled(Select)`
  .ant-select-selection {
    border: 1px solid #bdb2b2;
    height: 45px;
    font-size: 12px;
  }
  .ant-select-selection__placeholder {
    top: 21px;
  }
  .ant-select-selection__rendered {
    height: 44px;
  }
  .ant-select-selection-selected-value {
    position: relative;
    top: 6px;
  }
`;
const dataSource = [
  {
    key: '1',
    stockNumber: '120-221',
    name: '171 Bit',
    quantity: 110,
    meters: 110,
    price: 'R120.00',
    totals: 'R13 400.00'
  },
  {
    key: '2',
    stockNumber: '220-322',
    name: 'New Hammer 6”',
    quantity: 3,
    meters: 110,
    price: 'R999.99',
    totals: 'R3899.98'
  },
  {
    key: '3',
    stockNumber: '220-31',
    name: 'New Hammer 5”',
    quantity: 90,
    meters: 110,
    price: 'R400.00',
    totals: 'R36 000.00'
  },
  {
    key: '4',
    stockNumber: '120-221',
    name: 'DK Rod”',
    quantity: 30,
    meters: 110,
    price: 'R80.00',
    totals: 'R2400.00'
  },
  {
    key: '5',
    stockNumber: '120202',
    name: 'L8 Rod',
    quantity: 100,
    meters: 110,
    price: 'R120.00',
    totals: 'R12 000.00'
  }
];
const StyledBadge = styled(Badge)`
  .ant-badge-status-dot {
    height: 0.6em !important;
    width: 0.6em !important;
  }
`;
const EditableContext = React.createContext();
// const columns = [
//   {
//     title: 'Stock nr.',
//     dataIndex: 'serial',
//     key: 'serial',
//     width: "auto"
//   },
//   {
//     title: 'Tool Type',
//     dataIndex: 'size',
//     key: 'size',
//     width: 200
//   },
//   {
//     title: 'Description',
//     dataIndex: 'description',
//     key: 'description',
//   width: "auto"
//   },
//   {
//     title: 'Quantity',
//     dataIndex: 'totalQuantity',
//     key: 'totalQuantity',
//     width: 200
//   },
//   {
//     title: 'Price',
//     dataIndex: 'price',
//     width: 200,
//     key: 'price'
//   },
//   {
//     title: 'Total',
//     dataIndex: 'total',
//     width: 200,
//     key: 'total'
//   }
// ];
// const renderContent = (value, row, index) => {
//   const obj = {
//     children: value,
//     props: {},
//   };
//   if (index === 4) {
//     obj.props.colSpan = 0;
//   }
//   return obj;
// };
// const columns = [
//   {
//     title: 'Stock nr.',
//     dataIndex: 'serial',
//     render: (text, row, index) => {
//       if (index < 3) {
//         return <a>{text}</a>;
//       }
//       return {
//         children: <a>{text}</a>,
//         props: {
//           colSpan: 6,
//         },
//       };
//     },
//   },
//   {
//     title: 'Tool Type',
//     dataIndex: 'size',
//     render: renderContent,
//   },
//   {
//     title: 'Description',
//     colSpan: 7,
//     dataIndex: 'description',
//     render: (value, row, index) => {
//       const obj = {
//         children: value,
//         props: {},
//       };
//       if (index === 2) {
//         obj.props.rowSpan = 2;
//       }
//       // These two are merged into above cell
//       if (index === 3) {
//         obj.props.rowSpan = 0;
//       }
//       if (index === 4) {
//         obj.props.colSpan = 0;
//       }
//       return obj;
//     },
//   },
//   {
//     title: 'Quantity',
//     colSpan: 0,
//     dataIndex: 'totalQuantity',
//     render: renderContent,
//   },
//   {
//     title: 'Price',
//     dataIndex: 'price',
//     render: renderContent,
//   },
//   {
//     title: 'Total',
//     dataIndex: 'total',
//     render: renderContent,
//   },
//   {
//     title: 'Total',
//     dataIndex: 'total',
//     render: renderContent,
//   },
//   {
//     title: 'TotalAmount',
//     dataIndex: 'totalAmount',
//     render: renderContent,
//   },
// ];
const renderContent = (value, row, index) => {
  const obj = {
    children: value,
    props: {}
  };
  if (index === 4) {
    obj.props.colSpan = 0;
  }
  return obj;
};

const columns = [
  {
    title: 'Stock nr.',
    dataIndex: 'serial',
    key: 'serial',
    width: 95
  },
  {
    title: 'Tool Type',
    dataIndex: 'size',
    key: 'size',
    width: 100
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
    width: 170
  },
  {
    title: 'Quantity', // Add the "Total Quantity" column
    dataIndex: 'quantity',
    key: 'quantity',
    width: 100
  },
  {
    title: 'Date',
    dataIndex: 'date',
    key: 'date',
    width: 160
  },
  {
    title: 'Price', // Update to use "totalPrice" field
    dataIndex: 'totalPrice', // Use "totalPrice" instead of "price"
    key: 'price',
    width: 75,
    render: value => {
      const formattedValue = parseFloat(value).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      return <span>{formattedValue !== 'NaN' ? formattedValue : ''}</span>;
    }
  }
  // {
  //   title: 'Total',
  //   dataIndex: 'total',
  //   width: 75,
  //   key: 'total',
  //   render: total => {
  //     const formattedTotal = parseFloat(total).toLocaleString('en-US', {
  //       minimumFractionDigits: 2,
  //       maximumFractionDigits: 2
  //     });
  //     return <span>{formattedTotal != 'NaN' ? formattedTotal : ''}</span>;
  //   }
  // }
  // {
  //   title: 'Total Meters',
  //   dataIndex: 'totalMeters',
  //   width: 150,
  //   key: 'totalMeters',
  //   render: totalMeters => {
  //     const formattedPrice = parseFloat(totalMeters).toLocaleString('en-US', {
  //       minimumFractionDigits: 2,
  //       maximumFractionDigits: 2
  //     });
  //     return <span>{formattedPrice != "NaN" ? formattedPrice : ""}</span>;
  //   }

  // },
];
const damageColumns = [
  {
    title: 'Stock nr.',
    dataIndex: 'serial',
    key: 'serial'
  },
  {
    title: 'Tool Type',
    dataIndex: 'size',
    key: 'size',
    width: 100
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
    width: 160
  },
  {
    title: 'Reason',
    dataIndex: 'reason',
    key: 'reason',
    width: 100
  },
  {
    title: 'Date',
    dataIndex: 'date',
    key: 'date',
    width: 135,
    render: (date, record) => {
      return moment(record.date).format('YYYY-MM-DD HH:mm:ss');
    }
  },
  {
    title: 'Price',
    dataIndex: 'prices',
    width: 75,
    key: 'prices',
    render: price => {
      const formattedPrice = parseFloat(price).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

      return <span>{formattedPrice}</span>;
    }
  }
];
const data = []; // rowSelection objects indicates the need for row selection

for (let i = 50; i < 81; i++) {
  data.push({
    key: i,
    name: `Tool ${i}`,
    quantity: 32,
    price: <span> {i}.00</span>,
    totals: <span> {i}.00</span>
  });
}
const fixedColumns = [
  {
    title: 'Name',
    dataIndex: 'name',
    fixed: true,
    width: 100
  },
  {
    title: 'Description',
    dataIndex: 'description'
  }
];
const EditableRow = ({ form, index, ...props }) => (
  <EditableContext.Provider value={form}>
    <tr {...props} />
  </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);

class EditableCell extends React.Component {
  state = {
    editing: false
  };

  toggleEdit = () => {
    const editing = !this.state.editing;
    this.setState({ editing }, () => {
      if (editing) {
        this.input.focus();
      }
    });
  };

  save = e => {
    const { record, handleSave } = this.props;
    this.form.validateFields((error, values) => {
      if (error && error[e.currentTarget.id]) {
        return;
      }
      this.toggleEdit();
      handleSave({ ...record, ...values });
    });
  };

  addDescription = e => {
    const { record, handleSave } = this.props;
    this.form.validateFields((error, values) => {
      if (error && error[e]) {
        return;
      }
      this.toggleEdit();
      handleSave({ ...record, ...values });
    });
  };

  renderCell = form => {
    this.form = form;
    const { children, dataIndex, record, title, datasource } = this.props;
    const { editing } = this.state;
    return editing ? (
      <Form.Item style={{ margin: 0 }}>
        {form.getFieldDecorator(dataIndex, {
          rules: [
            {
              required: true,
              message: `${title} is required.`
            },
            {
              validator: this.props.validateQty
                ? (a, b, c) =>
                    this.props.validateQty(a, b, c, this.props.record)
                : null,
              message: `There is not enough stock to satisfy this quantity`
            }
          ],
          initialValue: record[dataIndex]
        })(
          <AutoComplete
            dataSource={datasource}
            placeholder={title + '...'}
            ref={node => (this.input = node)}
            //onPressEnter={this.save}
            onBlur={this.save}
            onSelect={this.addDescription}
            filterOption={(inputValue, option) =>
              inputValue.length > 2 &&
              option.props.children
                .toUpperCase()
                .indexOf(inputValue.toUpperCase()) !== -1
            }
          />
        )}
      </Form.Item>
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{ paddingRight: 24 }}
        onClick={this.toggleEdit}
      >
        {!children[2] && !record.addButton ? (
          <span style={{ opacity: 0.7 }}>
            {dataIndex === 'itemCode'
              ? 'Type 3 chars to search'
              : 'Click to edit...'}
          </span>
        ) : (
          children
        )}
      </div>
    );
  };

  render() {
    const {
      editable,
      dataIndex,
      title,
      record,
      index,
      handleSave,
      children,
      ...restProps
    } = this.props;
    return (
      <td {...restProps}>
        {editable ? (
          <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>
        ) : (
          children
        )}
      </td>
    );
  }
}
class RequisitionFormClass extends React.Component {
  editRequisition;
  state = {
    parts: []
  };
  componentWillMount = () => {
    if (this.props.editRequisition) {
      this.editRequisition = JSON.parse(
        JSON.stringify(this.props.editRequisition)
      );
      let parts = this.editRequisition.parts;
      parts.push({
        addButton: <Button onClick={this.addPart}>Add Part</Button>
      });
      this.setState({ parts: parts });
    } else {
      let parts = this.state.parts;
      parts.push({
        addButton: <Button onClick={this.addPart}>Add Part</Button>
      });
      this.setState({ parts: parts });
    }
  };
  componentWillUnmount = () => {
    this.editRequisition = undefined;
  };
  barcodeScanner = () => {
    window.cordova.plugins.barcodeScanner.scan(
      result => {
        this.props.form.setFieldsValue({
          itemCode: result.text
        });
      },
      error => {
        alert('Scanning failed: ' + error);
      },
      {
        preferFrontCamera: true,
        showFlipCameraButton: true,
        showTorchButton: true,
        prompt: 'Place a barcode inside the scan area'
      }
    );
  };
  addPart = () => {
    let parts = this.state.parts;
    parts.splice(parts.length - 1, 0, {
      key: parts.length - 1,
      itemCode: undefined,
      qty: undefined,
      description: undefined
    });
    this.setState({ parts: parts });
  };
  deletePart = part => {
    let parts = this.state.parts;
    const index = parts.findIndex(item => part.key === item.key);
    parts.splice(index, 1);
    this.setState({ parts: parts });
  };
  handleSave = row => {
    let parts = this.state.parts;
    const index = parts.findIndex(item => row.key === item.key);
    const item = parts[index];
    const codeCheck = row.itemCode.split('Part:')[1]
      ? row.itemCode
          .split('Part:')[1]
          .split('Location:')[0]
          .substring(1)
          .slice(0, -3)
      : row.itemCode;
    const stockIndex = this.props.stock.findIndex(
      stock => stock.itemCode === codeCheck
    );
    if (stockIndex > -1) {
      row.description = this.props.stock[stockIndex].description;
      row.location = this.props.stock[stockIndex].location;
      row.itemCode = this.props.stock[stockIndex].itemCode;
    }
    parts.splice(index, 1, {
      ...item,
      ...row
    });
    this.setState({ parts: parts });
  };
  validateQty = (rule, value, callback, record) => {
    const stockIndex = this.props.stock.findIndex(
      stock => stock.itemCode === record.itemCode
    );
    if (stockIndex > -1) {
      if (parseInt(this.props.stock[stockIndex].qty) >= parseInt(value)) {
        callback();
      } else {
        callback(false);
      }
    } else {
      callback(false);
    }
  };
  render() {
    const components = {
      body: {
        row: EditableFormRow,
        cell: EditableCell
      }
    };
    return (
      <Form
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 16 }}
        layout="horizontal"
      >
        <FormItem label={<span>Requisition Number</span>}>
          {this.props.form.getFieldDecorator('requisitionNumber', {
            // rules: [{ required: true, message: 'Description required' }],
            initialValue: this.editRequisition
              ? this.editRequisition.requisitionNumber
              : ''
          })(<Input />)}
        </FormItem>
        <FormItem label={<span>Job</span>}>
          {this.props.form.getFieldDecorator('jobNumber', {
            // rules: [{ required: true, message: 'Job required' }],
            initialValue: this.editRequisition
              ? this.editRequisition.jobNumber
              : undefined
          })(
            <Select
              defaultActiveFirstOption={false}
              showArrow={false}
              filterOption={false}
              notFoundContent={null}
              showSearch
              style={{ width: '100%' }}
              onSearch={this.props.handleSearchJob}
              placeholder={'Type in at least 4 characters to start search'}
            >
              {this.props.jobOptions}
            </Select>
          )}
        </FormItem>

        <FormItem label={<span>Technician</span>}>
          {this.props.form.getFieldDecorator('userName', {
            // rules: [{ required: true, message: 'Job required' }],
            initialValue: this.editRequisition
              ? this.editRequisition.userName
              : undefined
          })(
            <Select
              defaultActiveFirstOption={false}
              showArrow={false}
              filterOption={false}
              notFoundContent={null}
              showSearch
              style={{ width: '100%' }}
              onSearch={this.props.handleSearchTechnician}
              placeholder={'Type in at least 4 characters to start search'}
            >
              {this.props.technicianOptions}
            </Select>
          )}
        </FormItem>
        <FormItem label={<span>Parts List</span>}>
          <Table
            style={{ background: 'white' }}
            components={components}
            size="middle"
            pagination={{
              defaultPageSize: 10
            }}
            dataSource={this.state.parts}
          >
            <Column
              title="No"
              dataIndex="key"
              key="key"
              render={(text, record, index) => {
                if (!record.addButton) {
                  return <span>{index + 1}</span>;
                }
              }}
            />
            <Column
              title="Part Number"
              dataIndex="itemCode"
              key="itemCode"
              onCell={record => ({
                record,
                datasource: this.props.itemCodes,
                editable: true,
                dataIndex: 'itemCode',
                title: 'Part Number',
                handleSave: this.handleSave
              })}
            />
            <Column
              title="Description"
              dataIndex="description"
              key="description"
              onCell={record => ({
                record,
                editable: true,
                dataIndex: 'description',
                title: 'Description',
                handleSave: this.handleSave
              })}
            />
            <Column title="Location" dataIndex="location" key="location" />
            <Column
              title="Quantity"
              dataIndex="qty"
              key="qty"
              onCell={record => ({
                record,
                editable: true,
                dataIndex: 'qty',
                title: 'Quantity',
                record: record,
                validateQty: this.validateQty,
                handleSave: this.handleSave
              })}
            />
            <Column
              title="Meters"
              dataIndex="meters"
              key="meters"
              onCell={record => ({
                record,
                editable: true,
                dataIndex: 'meters',
                title: 'Meters',
                record: record,
                validateQty: this.validateQty,
                handleSave: this.handleSave
              })}
            />
            <Column
              title="Actions"
              key="actions"
              render={(text, requisition) => {
                if (!requisition.addButton) {
                  return (
                    <span>
                      <a onClick={e => this.deletePart(requisition)}>Delete</a>
                    </span>
                  );
                } else {
                  return requisition.addButton;
                }
              }}
            />
          </Table>
        </FormItem>
        <Row type="flex" justify="space-around" align="middle">
          <Button type="primary" onClick={this.props.onOk}>
            {this.props.okText}
          </Button>
          <Button type="primary" onClick={this.props.onCancel}>
            Cancel
          </Button>
        </Row>
      </Form>
    );
  }
}
const RequisitionForm = Form.create()(RequisitionFormClass);
class StockFormClass extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,

      itemCodes: [],
      removedMeters: null,
      newBitStatus: null,
      replaceSize: null,
      replaceDesc: null,
      replaceStatus: null,
      replaceLastUser: null,
      selectedBit: null,
      replaceSerial: null,
      visible: false
    };
  }
  barcodeScanner = () => {
    window.cordova.plugins.barcodeScanner.scan(
      result => {
        this.props.form.setFieldsValue({
          itemCode: result.text
        });
      },
      error => {
        alert('Scanning failed: ' + error);
      },
      {
        preferFrontCamera: true,
        showFlipCameraButton: true,
        showTorchButton: true,
        prompt: 'Place a barcode inside the scan area'
      }
    );
  };

  render() {
    let { selectedBit } = this.state;
    const bitStatus = {
      damaged: <StyledBadge color="#EE4C4C" text="Damaged" />,
      Used: <StyledBadge color="#EDAC4B" text="Used" />,
      new: <StyledBadge color="#4BED5B" text="New" />,
      lost: <StyledBadge color="#D4D4D4" text="Lost" />,
      used: <StyledBadge color="#EE4C4C" text="Used" />,
      out: <StyledBadge color="#FF8F28" text="Out" />
    };
    return (
      <div style={{ maxWidth: '90em', margin: 'auto' }}>
        <Form
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 14 }}
          layout="horizontal"
        >
          <FormItem label={<span>Rig Number</span>}>
            {this.props.form.getFieldDecorator('currentRig', {
              rules: [
                {
                  required: true,
                  message: 'Rig Number required'
                }
              ],
              initialValue: this.props.editStock
                ? this.props.editStock.currentRig
                : ''
            })(
              <Input
                disabled
                //type={"number"}
              />
            )}
          </FormItem>
          <FormItem label={<span>Tool Serial</span>}>
            {this.props.form.getFieldDecorator('itemCode', {
              rules: [{ required: true, message: 'Part number required' }],
              initialValue: this.props.editStock
                ? this.props.editStock.itemCode
                : ''
            })(
              <Input
                disabled
                suffix={
                  window.cordova ? (
                    <ScanOutlined onClick={this.barcodeScanner} />
                  ) : null
                }
              />
            )}
          </FormItem>
          <FormItem label={<span>Tool Type</span>}>
            {this.props.form.getFieldDecorator('toolType', {
              initialValue: this.props.editStock
                ? this.props.editStock.toolType
                : ''
            })(<Input disabled />)}
          </FormItem>
          <FormItem label={<span>Tool Description</span>}>
            {this.props.form.getFieldDecorator('itemDescription', {
              rules: [{ required: true, message: 'Description required' }],
              initialValue: this.props.editStock
                ? this.props.editStock.itemDescription
                : ''
            })(<Input disabled />)}
          </FormItem>
          <FormItem label={<span>Tool Status</span>}>
            {this.props.form.getFieldDecorator('Status', {
              rules: [{ required: false, message: 'Serial required' }],
              initialValue: this.props.editStock
                ? this.props.editStock.Status
                : ''
            })(
              <Select
                disabled
                placeholder="Status"
                onChange={newBitStatus => this.setState({ newBitStatus })}
              >
                <Option value="Damaged">
                  <StyledBadge color="#EE4C4C" text="Damaged" />
                </Option>
                <Option value="Used">
                  <StyledBadge color="#EDAC4B" text="Used" />
                </Option>
                <Option value="New">
                  <StyledBadge color="#4BED5B" text="New" />
                </Option>
                <Option value="Lost">
                  <StyledBadge color="#D4D4D4" text="Lost" />
                </Option>
              </Select>
            )}
          </FormItem>
          <FormItem label={<span>Meters</span>}>
            {this.props.form.getFieldDecorator('removedMeters', {
              rules: [{ required: false, message: 'Serial required' }],
              initialValue: this.props.editStock
                ? this.props.editStock.removedMeters
                : ''
            })(
              <Input
                disabled
                placeholder="Meters"
                onChange={e => this.setState({ removedMeters: e.target.value })}
              />
            )}
          </FormItem>
          {/*<FormItem>
          {this.props.form.getFieldDecorator("itemCode", {
            rules: [{ required: true, message: "Serial required" }],
          })(
            <Select
              placeholder='Serial'
              onChange={(bitSerial) => {
                const selectedBit = this.props.bits.find(
                  (bit) => bit.serial === bitSerial
                );
                this.setState({ selectedBit });
              }}
            >
              {this.props.bits.map((bitserial) => {
                return (
                  <Option value={bitserial.serial}>{bitserial.serial}</Option>
                );
              })}{" "}
              <Option value='test'>test</Option>
            </Select>
          )}
        </FormItem>
        <FormItem>
          {this.props.form.getFieldDecorator("toolType", {
            rules: [{ required: true, message: "Type required" }],
            initialValue:
              selectedBit && selectedBit.size ? selectedBit.size : "No Size",
          })(
            <Select
              disabled
              //hidden={!selectedBit ? true : false}

              onChange={(e) => this.setState({ replaceSize: e })}
            >
              {this.props.bits.map((bitsize) => {
                return <Option value={bitsize.size}>{bitsize.size}</Option>;
              })}
            </Select>
          )}
        </FormItem>
        <FormItem>
          {this.props.form.getFieldDecorator("itemStatus", {
            rules: [{ required: true, message: "Status required" }],
            initialValue:
              selectedBit && selectedBit.status
                ? selectedBit.status
                : "No Status",
          })(
            <Select
              //hidden={!selectedBit ? true : false}
              disabled
              onChange={(e) => this.setState({ replaceStatus: e })}
            >
              <Option value='Damaged'>
                <StyledBadge color='#EE4C4C' text='Damaged' />
              </Option>
              <Option value='Used'>
                <StyledBadge color='#EDAC4B' text='Used' />
              </Option>
              <Option value='New'>
                <StyledBadge color='#4BED5B' text='New' />
              </Option>
              <Option value='Lost'>
                <StyledBadge color='#D4D4D4' text='Lost' />
              </Option>
            </Select>
          )}
        </FormItem>{" "}
        <FormItem>
          {this.props.form.getFieldDecorator("itemDescription", {
            rules: [{ required: true, message: "Description required" }],
            initialValue:
              selectedBit && selectedBit.description
                ? selectedBit.description
                : "No Description",
          })(
            <Select
              disabled
              //hidden={!selectedBit ? true : false}

              onChange={(e) => this.setState({ replaceDesc: e })}
            >
              {this.props.bits.map((bitdesc) => {
                return (
                  <Option value={bitdesc.description}>
                    {bitdesc.description}
                  </Option>
                );
              })}
            </Select>
          )}
        </FormItem>*/}
          <Row>
            {/*<Button
              type='primary'
              shape='round'
              onClick={this.props.onOk}
              size='large'
              style={{
                float: "right",
                fontSize: "14px",
                width: "7em",
                height: "3em",
                //height: "3em",
                marginLeft: "0.7em",
              }}
            >
              Save
            </Button>*/}
            <Button
              shape="round"
              onClick={this.props.onCancel}
              style={{
                fontSize: '14px',
                width: '7em',
                height: '3em',

                border: '1px solid #EEEFF0',
                backgroundColor: '#EEEFF0',
                float: 'right'
              }}
            >
              Cancel
            </Button>
          </Row>
        </Form>
      </div>
    );
  }
}
const StockForm = Form.create()(StockFormClass);

class Stock extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      closed: false,
      filteredInfo: null,
      rejectReason: '',
      jobNumbers: [],
      jobNumber: undefined,
      rigSelected: 'all',
      technician: undefined,
      technicians: [],
      pitSelected: 'all',
      qty: 1,
      qtyError: false,
      itemCodes: [],
      startDate: moment().startOf('month'),
      endDate: moment().endOf('month'),
      siteSelected:
        this.props.sites.length > 0 && this.props.user.type !== 'admin'
          ? this.props.user.access
          : this.props.sites.length > 0 && this.props.user.type === 'admin'
          ? this.props.sites[0]._id
          : 'None'
    };
  }
  updateSignal;
  componentWillMount = () => {
    this.setState({ loading: true });
    this.props
      .findAllStock()
      .then(() => {
        let itemCodes = [];
        this.props.stock.forEach(stock => {
          if (stock.itemCode) {
            itemCodes.push(
              'Part: ' + stock.itemCode + ' - Location: ' + stock.location
            );
          }
        });
        this.props
          .findAllBits()
          .then(() => {
            this.props
              .findAllSites()
              .then(() => {
                this.setState({
                  loading: false,
                  itemCodes: itemCodes,
                  siteSelected:
                    this.props.sites.length > 0 &&
                    this.props.user.type !== 'admin'
                      ? this.props.user.access
                      : this.props.user.type === 'admin'
                      ? this.props.sites[0]._id
                      : 'None',
                  pitSelected: 'all',
                  rigSelected: 'all'
                });
              })
              .catch(e => {
                this.setState({ loading: false });
                Notify('error', e);
              });
          })
          .catch(e => {
            this.setState({ loading: false });
            Notify('error', e);
          });
      })
      .catch(e => {
        this.setState({ loading: false });
        Notify('error', e);
      });
    this.updateSignal = {
      signal: msg => {
        this.props
          .findAllStock()
          .then(() => {
            let itemCodes = [];
            this.props.stock.forEach(stock => {
              if (stock.itemCode) {
                itemCodes.push(
                  'Part: ' + stock.itemCode + ' - Location: ' + stock.location
                );
              }
            });
            this.setState({ loading: false, itemCodes: itemCodes });
          })
          .catch(e => {
            this.setState({ loading: false });
            Notify('error', e);
          });
      }
    };
    window.pubnub.addListener(this.updateSignal);
    window.addEventListener('resize', this.resizeEvent);
    if (window.cordova) {
      document.addEventListener('backbutton', this.handleBack);
    }
  };

  handleBack = () => {
    if (this.state.addStockVisible) {
      this.setState({ addStockVisible: false });
    } else {
      this.props.history.goBack();
    }
  };

  componentWillUnmount = () => {
    window.pubnub.removeListener(this.updateSignal);
    window.removeEventListener('resize', this.resizeEvent);
    if (window.cordova) {
      document.removeEventListener('backbutton', this.handleBack);
    }
  };

  resizeEvent = () => {
    this.setState({ loading: false });
  };
  parseString = string => {
    return parseInt(string.split('R')[1].replace(/,/g, ''));
  };
  formatNumber = number => {
    return 'R' + numeral(number).format('0,0');
  };

  handleSelectStock = e => {
    this.props.setStockDetailsId(e.currentTarget.getAttribute('data'));
    this.props.push('/admin/stockdetails');
  };
  handleSort = (pagination, filters, sorter) => {
    const columnKey = sorter.columnKey;
    const order = sorter.order;
    let stock = this.state.stock;
    if (order === 'ascend') {
      stock.sort((a, b) => parseInt(a[columnKey]) - parseInt(b[columnKey]));
    } else if (order === 'descend') {
      stock.sort((a, b) => parseInt(b[columnKey]) - parseInt(a[columnKey]));
    }
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter
    });
  };
  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };
  handleChange = (pagination, filters, sorter) => {
    console.log('Various parameters', pagination, sorter);
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter
    });
  };
  clearFilters = () => {
    this.setState({ filteredInfo: null });
  };
  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text =>
      text ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        ''
      )
  });
  onAddStock = e => {
    this.setState({ addStockVisible: true, editStock: undefined });
  };
  onEditStock = e => {
    this.setState({ addStockVisible: true, editStock: e });
  };
  onEditStockApprove = stock => {
    this.setState({ loading: true });
    if (stock.status === 'In Request') {
      stock.qty = parseInt(stock.qty) + 1;
    } else if (stock.status === 'Out Request') {
      stock.qty = parseInt(stock.qty) - 1;
    }
    stock.status = 'None';
    this.props
      .addStock(stock)
      .then(() => {
        this.props
          .findAllStock()
          .then(() => {
            this.props
              .sendNotification(
                stock.requestId,
                [stock.requestId],
                'Admin has approved one of your requests',
                'adminChanged',
                stock._id,
                false,
                'Beowolf Mining Admin'
              )
              .then(() => {
                this.setState({ loading: false });
                Notify('success', 'Successfully approved request');
              })
              .catch(e => {
                this.setState({ loading: false });
                Notify('error', e);
              });
          })
          .catch(e => {
            this.setState({ loading: false });
            Notify('error', e);
          });
      })
      .catch(e => {
        this.setState({ loading: false });
        Notify('error', e);
      });
  };
  handleAddStock = e => {
    e.preventDefault();
    this.stockForm.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.setState({ loading: true });
        if (this.state.editStock) {
          values._id = this.state.editStock._id;
        }
        this.props
          .addStock(values)
          .then(() => {
            this.props
              .findAllStock()
              .then(() => {
                if (this.state.editStock) {
                  Notify('success', 'Successfully saved stock');
                } else {
                  Notify('success', 'Successfully added stock');
                }
                this.stockForm.props.form.resetFields();
                let itemCodes = [];
                this.props.stock.forEach(stock => {
                  if (stock.itemCode) {
                    itemCodes.push(
                      'Part: ' +
                        stock.itemCode +
                        ' - Location: ' +
                        stock.location
                    );
                  }
                });
                this.setState({ itemCodes: itemCodes });
                this.setState({
                  loading: false,
                  addStockVisible: false,
                  editStock: undefined
                });
              })
              .catch(e => {
                this.setState({ loading: false });
                Notify('error', e);
              });
          })
          .catch(e => {
            this.setState({ loading: false });
            Notify('error', e);
          });
      }
    });
  };
  onEditStockOutVisible = stock => {
    if (parseInt(stock.qty) === 0) {
      Notify('error', 'There is no stock left');
      return;
    }
    this.setState({
      stockOut: stock,
      outVisible: true
    });
  };
  onEditStockOut = () => {
    let stock = this.state.stockOut;
    if (this.state.qtyError === true || this.state.qty === 0) {
      return;
    }
    if (parseInt(stock.qty) === 0) {
      Notify('error', 'There is no stock left');
      return;
    }
    const id = stock._id;
    let request = {
      qty: this.state.qty,
      jobNumber: this.state.jobNumber,
      stockId: id,
      type: 'Out',
      itemCode: stock.itemCode,
      description: stock.description,
      userName: this.state.userName,
      requisitionNumber: this.state.requisitionNumber,
      approved: true
    };
    this.setState({ loading: true, outVisible: false });
    this.props
      .addRequest(request)
      .then(() => {
        this.props
          .findAllStock()
          .then(() => {
            let itemCodes = [];
            this.props.stock.forEach(stock => {
              if (stock.itemCode) {
                itemCodes.push(
                  'Part: ' + stock.itemCode + ' - Location: ' + stock.location
                );
              }
            });
            this.setState({ itemCodes: itemCodes });
            const { vfs } = vfsFonts.pdfMake;
            pdfMake.vfs = vfs;
            let data = Object.assign({}, request);
            prepDefinition(data).then(definition => {
              pdfMake
                .createPdf(definition)
                .download(
                  stock.itemCode +
                    ' ' +
                    moment().format('YYYY-MM-DD') +
                    ' Approved Request.pdf',
                  () => {
                    this.setState({ loading: false, qty: 1, qtyError: false });
                    Notify('success', 'Successfully submitted');
                  }
                );
            });
          })
          .catch(e => {
            this.setState({ loading: false });
            Notify('error', e);
          });
      })
      .catch(e => {
        this.setState({ loading: false });
        Notify('error', e);
      });
  };
  handleEditBatchStockOut = e => {
    e.preventDefault();
    this.requisitionForm.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        for (var i = 0; i < this.requisitionForm.state.parts.length; i++) {
          if (!this.requisitionForm.state.parts[i].addButton) {
            if (!this.requisitionForm.state.parts[i].qty) {
              return;
            }
          }
        }
        this.setState({ loading: true });
        if (this.state.editRequisition) {
          values._id = this.state.editRequisition._id;
        }
        values.parts = this.requisitionForm.state.parts;
        values.type = 'Out';
        values.approved = true;
        this.props
          .addBatchRequest(values)
          .then(() => {
            this.props
              .findAllStock()
              .then(() => {
                let itemCodes = [];
                this.props.stock.forEach(stock => {
                  if (stock.itemCode) {
                    itemCodes.push(
                      'Part: ' +
                        stock.itemCode +
                        ' - Location: ' +
                        stock.location
                    );
                  }
                });
                this.setState({ itemCodes: itemCodes });
                const { vfs } = vfsFonts.pdfMake;
                pdfMake.vfs = vfs;
                let data = Object.assign({}, values);
                prepDefinition2(data).then(definition => {
                  pdfMake
                    .createPdf(definition)
                    .download(
                      values.requisitionNumber +
                        ' ' +
                        moment().format('YYYY-MM-DD') +
                        ' Approved Request.pdf',
                      () => {
                        this.setState({
                          loading: false,
                          addBatchVisible: false
                        });
                        Notify('success', 'Successfully submitted');
                      }
                    );
                });
              })
              .catch(e => {
                this.setState({ loading: false });
                Notify('error', e);
              });
          })
          .catch(e => {
            this.setState({ loading: false });
            Notify('error', e);
          });
      }
    });
  };
  handleDeleteStock = e => {
    this.setState({ loading: true, deleteVisible: false });
    const data = this.state.deleteStock;
    this.props
      .deleteStock(data._id)
      .then(() => {
        this.props
          .findAllStock()
          .then(() => {
            let itemCodes = [];
            this.props.stock.forEach(stock => {
              if (stock.itemCode) {
                itemCodes.push(
                  'Part: ' + stock.itemCode + ' - Location: ' + stock.location
                );
              }
            });
            this.setState({ loading: false, itemCodes: itemCodes });
            Notify('success', 'Deleted stock', 'Successfully deleted stock.');
          })
          .catch(e => {
            this.setState({ loading: false });
            Notify('error', e);
          });
        this.setState({ loading: false });
      })
      .catch(e => {
        this.setState({ loading: false });
        Notify('error', e);
      });
  };
  handleSearchJob = e => {
    if (e.length > 3) {
      this.props
        .findJobNumbers(e)
        .then(suc => {
          this.setState({
            jobNumbers: suc.jobNumbers
          });
        })
        .catch(e => {
          this.setState({ loading: false });
          Notify('error', e);
        });
    } else {
      this.setState({
        jobNumbers: []
      });
    }
  };
  handleSearchTechnician = e => {
    if (e.length > 3) {
      this.props
        .findTechnicians(e)
        .then(suc => {
          this.setState({
            technicians: suc.technicians
          });
        })
        .catch(e => {
          this.setState({ loading: false });
          Notify('error', e);
        });
    } else {
      this.setState({
        technicians: []
      });
    }
  };
  cancelDelete = e => {
    this.setState({ deleteVisible: false, deleteStock: '' });
  };
  checkQty = e => {
    let setQty = e;
    if (setQty !== '' && setQty !== null) {
      if (this.state.stockOut.qty < setQty) {
        this.setState({
          qty: parseInt(setQty),
          qtyError: true
        });
      } else {
        this.setState({
          qty: parseInt(setQty),
          qtyError: false
        });
      }
    } else {
      this.setState({
        qty: 1,
        qtyError: false
      });
    }
  };
  renderStatus = (status, color) => {
    return (
      <p style={{ margin: 0 }}>
        <StyledBadge color={color} style={{}} />
        {status}
      </p>
    );
  };

  render() {
    const { stock, bits } = this.props;
    let {
      sortedInfo,
      filteredInfo,
      startDate,
      endDate,
      siteSelected,
      rigSelected
    } = this.state;
    filteredInfo = filteredInfo || {};

    // --- build dropdown options ---
    const jobOptions = this.state.jobNumbers.map(d => (
      <Option key={d.sysRefNo}>{d.sysRefNo}</Option>
    ));
    const technicianOptions = this.state.technicians.map(d => (
      <Option key={d.username} value={d.name}>
        {d.name + ' – ' + d.username.split('|')[1]}
      </Option>
    ));

    // --- process bits ---
    const accessibleBits = bits.filter(
      bit => Array.isArray(bit.access) && bit.access.includes(siteSelected)
    );
    const bitsAggregated = [];
    accessibleBits.forEach(bit => {
      if (!Array.isArray(bit.cost)) return;
      bit.cost.forEach(costEntry => {
        if (moment(costEntry.date).isBetween(startDate, endDate, 'day', '[]')) {
          bit.totalQuantity = (bit.totalQuantity || 0) + 1;
          bit.totalMeters =
            (bit.totalMeters || 0) + parseFloat(costEntry.meters || 0);
          const idx = bitsAggregated.findIndex(b => b._id === bit._id);
          if (idx > -1) bitsAggregated[idx] = bit;
          else bitsAggregated.push(bit);
        }
      });
    });

    // --- compute totals for bits ---
    let totalAmount = 0;

    bitsAggregated.forEach(bit => {
      bit.total = bit.totalQuantity * parseFloat(bit.price || 0);
      totalAmount += bit.total;
      totalMeters += bit.totalMeters;
    });
    const totalRandPerMeter = totalMeters > 0 ? totalAmount / totalMeters : 0;

    // --- process rigs ---
    const accessibleRigs = stock.filter(
      rig =>
        rig.access === siteSelected &&
        (rigSelected === 'all' || rig.currentRig === rigSelected)
    );
    const rigsProcessed = accessibleRigs.map(rig => {
      const r = { ...rig };

      // filter and sum cost entries
      r.totalCost = 0;
      if (Array.isArray(r.cost)) {
        r.cost = r.cost.filter(c => {
          if (!moment(c.date).isBetween(startDate, endDate, 'day', '[]')) {
            return false;
          }

          // calculate with "None" → zero
          const base = parseFloat(c.price || 0);
          let price;
          if (c.status === 'Reissued') {
            price = -Math.abs(base);
          } else if (c.status === 'None') {
            price = 0;
          } else if (c.status === 'Used') {
            price = 0;
          } else {
            price = base;
          }

          r.totalCost += price;
          return true;
        });
      } else {
        r.cost = [];
      }

      // filter and sum meter updates
      r.totalMeters = 0;
      if (Array.isArray(r.meterUpdates)) {
        r.meterUpdates = r.meterUpdates.filter(mu => {
          if (moment(mu.date).isBetween(startDate, endDate, 'day', '[]')) {
            r.totalMeters += parseFloat(mu.meters || 0);
            return true;
          }
          return false;
        });
      } else {
        r.meterUpdates = [];
      }

      return r;
    });

    const grandTotalCost = rigsProcessed.reduce(
      (sum, r) => sum + r.totalCost,
      0
    );
    const grandTotalMeters = rigsProcessed.reduce(
      (sum, r) => sum + r.totalMeters,
      0
    );
    const grandCostPerMeter =
      grandTotalMeters > 0 ? grandTotalCost / grandTotalMeters : 0;

    // --- merge & sort all cost entries ---
    const mergedCosts = rigsProcessed.flatMap(r => r.cost);
    const sortedCosts = [...mergedCosts].sort((a, b) =>
      a.toolSerial && b.toolSerial
        ? a.toolSerial.localeCompare(b.toolSerial)
        : 0
    );

    // --- group by description ---
    const groupedCosts = [];

    sortedCosts.forEach(item => {
      const description = item.description?.trim() || 'Unknown'; // Handle missing descriptions
      const quantityEffect =
        item.status === 'Reissued'
          ? -1
          : item.status === 'None'
          ? 0
          : item.status === 'Used'
          ? 0
          : 1;
      const price = parseFloat(item.price || 0);
      const meters = parseFloat(item.totalMeters || 0);
      const cost = parseFloat(item.totalCost || 0);

      let existing = groupedCosts.find(g => g.description === description);

      if (existing) {
        existing.quantity += quantityEffect;
        existing.totalMeters += quantityEffect * meters;
        existing.totalCost += quantityEffect * cost;
        existing.totalPrice += quantityEffect * price;
      } else {
        groupedCosts.push({
          ...item,
          description, // normalized
          quantity: quantityEffect,
          totalMeters: quantityEffect * meters,
          totalCost: quantityEffect * cost,
          totalPrice: quantityEffect * price
        });
      }
    });

    const rigs = rigsProcessed;

    // 1) Drop any Reissued rigs:
    const validRigs = rigsProcessed;
    // 2) Compute your totals off only the valid rigs:
    const totalMeters = validRigs.reduce(
      (sum, r) => sum + (r.totalMeters || 0),
      0
    );
    const totalCost = validRigs.reduce((sum, r) => sum + (r.totalCost || 0), 0);
    const invoiceTotal = groupedCosts.reduce(
      (sum, item) => sum + (Number(item.totalPrice) || 0),
      0
    );
    // 3) If you’re also exporting costs, drop Reissued entries there too:
    const exportableCosts = groupedCosts;
    const excelData = [...exportableCosts];
    excelData.push({
      serial: 'Cost per Meter',
      size: '',
      description: '',
      quantity: '',
      date: '',
      totalPrice: totalMeters ? (invoiceTotal / totalMeters).toFixed(2) : '0.00'
    });
    excelData.push({
      serial: 'Total Meters',
      size: '',
      description: '',
      quantity: '',
      date: '',
      totalPrice: totalMeters
    });
    excelData.push({
      serial: 'Invoice Total',
      size: '',
      description: '',
      quantity: '',
      date: '',
      totalPrice: invoiceTotal.toFixed(2)
    });
    // excelData.push({
    //   serial: 'Invoice Amount',
    //   size: '',
    //   description: '',
    //   totalQuantity: '',
    //   price: '',
    //   total: '',
    //   invoiceAmount: totalAmount.toLocaleString('en-US', {
    //     minimumFractionDigits: 2,
    //     maximumFractionDigits: 2
    //   })
    // });
    const pitNumbers = [...new Set(rigs.map(rig => rig.pitNr))];
    const handleExport = () => {
      const excel = new Excel();

      // ===== COSTS SHEET =====
      const costColumns = [
        { title: 'Stock Nr.', dataIndex: 'serial' },
        { title: 'Tool Type', dataIndex: 'size' },
        { title: 'Description', dataIndex: 'description' },
        { title: 'Quantity', dataIndex: 'quantity' },
        { title: 'Date', dataIndex: 'date' },
        { title: 'Total Price', dataIndex: 'totalPrice' }
      ];

      const costRows = exportableCosts.map(item => ({
        serial: item.serial,
        size: item.size,
        description: item.description,
        quantity: item.quantity,
        date: moment(item.date).format('YYYY-MM-DD HH:mm:ss'),
        totalPrice: parseFloat(item.totalPrice || 0).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
      }));

      const costSummary = [
        {
          serial: 'Total Meters',
          totalPrice: totalMeters.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })
        },
        {
          serial: 'Invoice Amount',
          totalPrice: invoiceTotal.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })
        },
        {
          serial: 'Total Cost per Meter',
          totalPrice: (totalMeters > 0
            ? (invoiceTotal -totalDamageAmount) / totalMeters
            : 0
          ).toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })
        }
      ];

      excel
        .addSheet('Costs')
        .addColumns(costColumns)
        .addDataSource([...costRows, ...costSummary]);

      // ===== DAMAGES SHEET =====
      const damageColumns = [
        { title: 'Stock Nr.', dataIndex: 'serial' },
        { title: 'Tool Type', dataIndex: 'size' },
        { title: 'Rig', dataIndex: 'currentRig' },
        { title: 'Reason', dataIndex: 'reason' },
        { title: 'Date', dataIndex: 'date' },
        { title: 'Total', dataIndex: 'prices' }
      ];

      const damageRows = damageData.map(item => ({
        serial: item.serial,
        size: item.size,
        currentRig: item.currentRig,
        reason: item.reason,
        date: moment(item.date).format('YYYY-MM-DD HH:mm:ss'),
        prices: parseFloat(item.prices || 0).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
      }));

      const damageSummary = [
        {
          serial: 'Total Damages',
          prices: totalDamageAmount.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })
        },
        // {
        //   serial: 'Cost Inc. Damages',
        //   prices: (invoiceTotal + totalDamageAmount).toLocaleString('en-US', {
        //     minimumFractionDigits: 2,
        //     maximumFractionDigits: 2
        //   })
        // },
        {
          serial: 'R/meter In Damages',
          prices: (totalMeters > 0
            ? (totalDamageAmount) / totalMeters
            : 0
          ).toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })
        }
      ];

      excel
        .addSheet('Damages')
        .addColumns(damageColumns)
        .addDataSource([...damageRows, ...damageSummary]);

      // Save the file
      excel.saveAs('Costs_and_Damages.xlsx');
    };
    // Function to generate the Excel file
    // const generateExcelFile = () => {
    //   const workbook = XLSX.utils.book_new();
    //   const worksheet = XLSX.utils.json_to_sheet(bits);

    //   // Initialize rows if not already defined
    //   if (!worksheet["!rows"]) {
    //     worksheet["!rows"] = [];
    //   }

    //   // Add the footer row manually
    //   const footerRow = {
    //     footerLabel1: "Footer Value 1",
    //     footerLabel2: "Footer Value 2",
    //   };
    //   const footerRowIndex = worksheet["!rows"].length;
    //   worksheet[`A${footerRowIndex + 1}`] = { t: "s", v: footerRow.footerLabel1 };
    //   worksheet[`B${footerRowIndex + 1}`] = { t: "s", v: footerRow.footerLabel2 };

    //   // Add the worksheet to the workbook
    //   XLSX.utils.book_append_sheet(workbook, worksheet, "Costs");

    //   // Generate the Excel file
    //   XLSX.writeFile(workbook, "excel_file.xlsx");
    // };

    // // Usage
    // const App = () => {
    //   return (
    //     <div>
    //       <button onClick={generateExcelFile}>Generate Excel File</button>
    //     </div>
    //   );
    // };

    const header = [
      'Stock nr.',
      'Tool Type',
      'Description',
      'Quantity',
      'Price',
      'Total',
      'Total'
    ];
    const footer = ['Footer Label 1', 'Footer Label 2']; // Example footer labels
    const body = [['Edison', 'Padilla', 14], ['Cheila', 'Rodrigez', 56]];

    /**
     * @description:
     *  also accepts an array of objects; the method (downloadExcel) will take
     *  as order of each column, the order that each property of the object brings with it.
     *  the method(downloadExcel) will only take the value of each property.
     */
    const body2 = bits.map(bit => ({
      serial: bit.serial,
      size: bit.size,
      description: bit.description,
      totalQuantity: bit.totalQuantity,
      price: bit.price,
      total: bit.total,
      total: bit.totalAmount
    }));

    function handleDownloadExcel() {
      downloadExcel({
        fileName: 'react-export-table-to-excel -> downloadExcel method',
        sheet: 'react-export-table-to-excel',
        tablePayload: {
          header,
          // accept two different data structures
          body: body2 || body2,
          footer
        }
      });
    }
    // 1) Only bits for the selected site
    const unBits = bits.filter(
      bit =>
        Array.isArray(bit.access) &&
        bit.access.includes(this.state.siteSelected)
    );

    // 2) For each bit, filter its damage entries by date and compute totals
    const bitsWithTotals = unBits
      .map(bit => {
        // filter damages in-range
        const filteredDamage = (bit.damage || []).filter(d =>
          moment(d.date).isBetween(
            this.state.startDate,
            this.state.endDate,
            'day',
            '[]'
          )
        );

        const totalQuantity = filteredDamage.length;
        const totalMeters = filteredDamage.reduce(
          (sum, d) => sum + parseFloat(d.meters || 0),
          0
        );
        const totalAmount = filteredDamage.reduce(
          (sum, d) => sum + parseFloat(d.prices || 0),
          0
        );

        return {
          ...bit,
          damage: filteredDamage,
          totalQuantity,
          totalMeters,
          totalAmount,
          lineTotal: totalQuantity * parseFloat(bit.price || 0)
        };
      })
      // 3) drop any bits with no damage in range
      .filter(bit => bit.totalQuantity > 0);

    // 4) Grand totals
    const grandMeters = bitsWithTotals.reduce(
      (sum, b) => sum + b.totalMeters,
      0
    );
    const grandAmount = bitsWithTotals.reduce(
      (sum, b) => sum + b.totalAmount,
      0
    );
    const randPerMeter = grandAmount / (grandMeters || 1);

    const damageData = bits
      .filter(bit => bit.access.includes(this.state.siteSelected))
      .flatMap(bit => {
        if (Array.isArray(bit.damage) && bit.damage.length > 0) {
          return bit.damage.map((update, i) => ({
            ...bit,
            reason: update.reason,
            currentRig: update.currentRig,
            prices: update.prices,
            date: update.date,
            key: `${bit._id}_${i}`
          }));
        }
        return [];
      })
      .filter(item => !isNaN(item.prices))
      .filter(item => {
        if (!this.state.startDate || !this.state.endDate) return true;
        return moment(item.date).isBetween(
          this.state.startDate,
          this.state.endDate,
          'day',
          '[]'
        );
      })
      .sort((a, b) => moment(b.date).unix() - moment(a.date).unix());

    // compute summary total
    const totalDamageAmount = damageData.reduce(
      (sum, x) => sum + parseFloat(x.prices || 0),
      0
    );

    // build your “totals” row matching your columns’ dataIndex keys
    const totalsRow = {
      reason: 'Totals',
      currentRig: '',
      prices: totalDamageAmount,
      date: '',
      key: 'totals-row'
    };

    return (
      <div>
        <Row
          type="flex"
          justify="start"
          align="middle"
          style={{ textAlign: 'center', maxWidth: '90em', margin: 'auto' }}
        >
          <Col xs={24} md={24} style={{ textAlign: 'left' }}>
            <span style={{ fontWeight: 750, fontSize: 30 }}>
              Costs -
              {/* <span style={{ color: '#FF9D66', fontWeight: 750, fontSize: 30 }}>
                {moment().format('DD/MM/YY')}
              </span> */}
            </span>{' '}
            <StyledSelect
              value={this.state.siteSelected}
              onChange={e => {
                this.setState({ siteSelected: e });
              }}
              defaultValue={this.state.siteSelected}
              style={{ height: 55, marginLeft: '1em', minWidth: '10em' }}
            >
              {this.props.sites.map(site =>
                site._id === this.props.user.access ? (
                  <Option value={site._id}>{site.name}</Option>
                ) : this.props.user.type === 'admin' ? (
                  <Option value={site._id}>{site.name}</Option>
                ) : null
              )}
            </StyledSelect>
            {/* <StyledSelect
              value={this.state.pitSelected}
              onChange={e => {
                this.setState({ pitSelected: e });
              }}
              defaultValue={this.state.pitSelected}
              style={{ height: 55, marginLeft: '1em', minWidth: '6em' }}
            >
              {' '}
              <Option value="all">All Pits</Option>{' '}
              {pitNumbers.map(pitNumber => (
                <Option value={pitNumber}>{pitNumber}</Option>
              ))}
            </StyledSelect> */}
            <Button
              onClick={handleExport}
              type="primary"
              style={{
                zIndex: 999,
                backgroundColor: '#EC8144',
                color: 'white',
                border: '1px solid #EC8144',
                borderRadius: '3em',
                marginLeft: '1em',
                height: '3em',
                width: '8em',
                marginTop: '1em',
                float: 'right',
                cursor: 'pointer'
              }}
            >
              Export
            </Button>
            {/* <ExcelFile
              element={
                <button
                  style={{
                    backgroundColor: '#EC8144',
                    color: 'white',
                    border: '1px solid #EC8144',
                    borderRadius: '3em',
                    marginLeft: '1em',
                    height: '3em',
                    width: '8em',
                    marginTop: '1em',
                    float: 'right',
                    cursor: 'pointer'
                  }}
                >
                  Export
                </button>
              }
            >
              <ExcelSheet data={bits} name="Costs">
                <ExcelColumn label="Stock nr." value="serial" />
                <ExcelColumn label="Tool Type" value="size" />
                <ExcelColumn label="Description" value="description" />
                <ExcelColumn label="Quantity" value="totalQuantity" />
                <ExcelColumn label="Price" value="price" />
                <ExcelColumn label="Total" value="total" />
              </ExcelSheet>
              <ExcelSheet data={dataSet2} name="Leaves">
                  <ExcelColumn label="Name" value="name" />
                  <ExcelColumn label="Total Leaves" value="total" />
                  <ExcelColumn label="Remaining Leaves" value="remaining" />
                </ExcelSheet>
            </ExcelFile> */}
            <StyledDatePicker
              allowClear={false}
              style={{ float: 'right', marginTop: '1em' }}
              onChange={dates => {
                if (!dates || dates.length === 0) {
                  // user cleared the range
                  this.setState({ startDate: null, endDate: null });
                } else {
                  // normal pick
                  this.setState({ startDate: dates[0], endDate: dates[1] });
                }
              }}
              value={[this.state.startDate, this.state.endDate]}
              format={dateFormat}
            />
          </Col>
        </Row>

        <div style={{ maxWidth: '90em', margin: 'auto' }}>
          <Spin spinning={this.state.loading}>
            {/* {this.state.addStockVisible ? ( */}
            <Row
              style={{
                background: 'white',
                borderRadius: 5,
                marginTop: 20,
                display: this.state.addStockVisible ? 'flex' : 'none'
              }}
              type="flex"
              justify="space-around"
              align="middle"
            >
              <Col style={{ padding: 20 }} span={20}>
                <StockForm
                  editStock={this.state.editStock}
                  wrappedComponentRef={form => (this.stockForm = form)}
                  onOk={this.handleAddStock}
                  onCancel={e => this.setState({ addStockVisible: false })}
                  okText={this.state.editStock ? 'Save' : 'Add Stock'}
                />
              </Col>
            </Row>
            {/* ) : this.state.addBatchVisible ? ( */}
            <Row
              style={{
                background: 'white',
                borderRadius: 5,
                marginTop: 20,
                display: this.state.addBatchVisible ? 'flex' : 'none'
              }}
              type="flex"
              justify="space-around"
              align="middle"
            >
              <Col style={{ padding: 20 }} span={20}>
                <RequisitionForm
                  handleSearchJob={this.handleSearchJob}
                  handleSearchTechnician={this.handleSearchTechnician}
                  jobOptions={jobOptions}
                  technicianOptions={technicianOptions}
                  itemCodes={this.state.itemCodes}
                  stock={this.props.stock}
                  editRequisition={this.state.editRequisition}
                  wrappedComponentRef={form => (this.requisitionForm = form)}
                  onOk={this.handleEditBatchStockOut}
                  onCancel={e => this.setState({ addBatchVisible: false })}
                  okText={
                    this.state.editRequisition
                      ? 'Save'
                      : 'Submit Batch Stock Out'
                  }
                />
              </Col>
            </Row>
            {/* ) : ( */}
            <Row
              style={{
                background: 'white',
                borderRadius: 5,
                marginTop: 20,
                display:
                  !this.state.addStockVisible && !this.state.addBatchVisible
                    ? 'flex'
                    : 'none'
              }}
              type="flex"
              justify="start"
              align="middle"
            >
              {/* <div>
                <button onClick={handleDownloadExcel}>Download Excel</button>

                <table>
                  <thead>
                    <tr>
                      {header.map((head) => (
                        <th key={head}>{head}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {body.map((item, i) => (
                      <tr key={i}>
                        {item.map((it) => (
                          <td key={it}>{it}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      {footer.map((foot) => (
                        <td key={foot}>{foot}</td>
                      ))}
                    </tr>
                  </tfoot>
                </table>
              </div> */}

              <Col span={24}>
                <StyledTable
                  // rowClassName={record =>
                  //   record.status === 'Reissued' ? 'red-row' : ''
                  // }
                  dataSource={exportableCosts} // Use the preprocessed data here
                  scroll={{
                    // x: 1500,
                    y: 600
                  }}
                  pagination={{
                    defaultPageSize: 15
                  }}
                  summary={() => (
                    <Table.Summary>
                      {/* … */}
                      <Table.Summary.Row
                        style={{
                          backgroundColor: '#F0F3F9',

                          fontWeight: 500,
                          fontSize: '15px'
                        }}
                      >
                        <Table.Summary.Cell colSpan={5}>
                          Total Cost per Meter
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          {totalMeters
                            ? ((invoiceTotal- totalDamageAmount) / totalMeters).toLocaleString(
                                'en-US',
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                }
                              )
                            : '0.00'}
                        </Table.Summary.Cell>
                      </Table.Summary.Row>

                      <Table.Summary.Row
                        style={{
                          backgroundColor: '#F0F3F9',

                          fontWeight: 500,
                          fontSize: '15px'
                        }}
                      >
                        <Table.Summary.Cell colSpan={5}>
                          Total Meters
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>{totalMeters}</Table.Summary.Cell>
                      </Table.Summary.Row>

                      <Table.Summary.Row
                        style={{
                          backgroundColor: '#F0F3F9',

                          fontWeight: 500,
                          fontSize: '15px'
                        }}
                      >
                        <Table.Summary.Cell colSpan={5}>
                          Invoice Amount
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          {invoiceTotal.toLocaleString('en-US', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          })}
                        </Table.Summary.Cell>
                      </Table.Summary.Row>
                    </Table.Summary>
                  )}
                >
                  {/* <Column
                    title="Serial Nr."
                    dataIndex="toolSerial"
                    key="toolSerial"
                  /> */}

                  <Column
                    {...this.getColumnSearchProps('serial')}
                    title="Stock Nr."
                    dataIndex="serial"
                    key="serial"
                  />
                  {window.innerWidth > 420 ? (
                    <Column
                      {...this.getColumnSearchProps('size')}
                      title="Tool Type"
                      dataIndex="size"
                      key="size"
                    />
                  ) : null}
                  {window.innerWidth > 420 ? (
                    <Column
                      //{...this.getColumnSearchProps("size")}
                      title="Description"
                      dataIndex="description"
                      key="description"
                    />
                  ) : null}
                  <Column
                    //{...this.getColumnSearchProps("size")}
                    title="Quantity"
                    dataIndex="quantity"
                    key="quantity"
                  />
                  {window.innerWidth > 420 ? (
                    <Column
                      {...this.getColumnSearchProps('date')}
                      title="Date"
                      dataIndex="date"
                      key="date"
                      render={text => {
                        const formattedDate = moment(text).format(
                          'YYYY-MM-DD HH:mm:ss'
                        );
                        return formattedDate;
                      }}
                    />
                  ) : null}
                  {window.innerWidth > 420 ? (
                    <Column
                      //{...this.getColumnSearchProps("size")}
                      title="Price"
                      dataIndex="totalPrice" // Use the totalPrice property from the preprocessed data
                      key="price"
                      render={text => (
                        <span>
                          {parseFloat(text).toLocaleString('en-US', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          })}
                        </span>
                      )}
                    />
                  ) : null}
                </StyledTable>
              </Col>
            </Row>
            <Row
              style={{
                background: 'white',
                borderRadius: 5,
                marginTop: 20,
                display:
                  !this.state.addStockVisible && !this.state.addBatchVisible
                    ? 'flex'
                    : 'none'
              }}
              type="flex"
              justify="start"
              align="middle"
            >
              <Col span={24} style={{ marginTop: '2em' }}>
                <span style={{ fontWeight: 750, fontSize: 30 }}>
                  Damages -
                  {/* <span style={{ color: '#FF9D66', fontWeight: 750, fontSize: 30 }}>
                {moment().format('DD/MM/YY')}
              </span> */}
                </span>{' '}
              </Col>
              <Col span={24} style={{ marginTop: '2em' }}>
                <StyledTable
                  dataSource={damageData}
                  scroll={{ y: 600 }}
                  pagination={{ defaultPageSize: 9 }}
                  summary={() => (
                    <Table.Summary>
                      <Table.Summary.Row
                        style={{
                          backgroundColor: '#F0F3F9',
                          fontWeight: 500,
                          fontSize: '15px'
                        }}
                      >
                        <Table.Summary.Cell index={0} colSpan={5}>
                          Total Damages
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={5} colSpan={1}>
                          {totalDamageAmount.toLocaleString('en-US', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          })}
                        </Table.Summary.Cell>
                      </Table.Summary.Row>

                      <Table.Summary.Row
                        style={{
                          backgroundColor: '#F0F3F9',
                          fontWeight: 500,
                          fontSize: '15px'
                        }}
                      >
                        {/* <Table.Summary.Cell index={0} colSpan={5}>
                          Total Including Damages
                        </Table.Summary.Cell> */}
                        {/* <Table.Summary.Cell index={5} colSpan={1}>
                          {(invoiceTotal + totalDamageAmount).toLocaleString(
                            'en-US',
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            }
                          )}
                        </Table.Summary.Cell> */}
                      </Table.Summary.Row>

                      <Table.Summary.Row
                        style={{
                          backgroundColor: '#F0F3F9',
                          fontWeight: 500,
                          fontSize: '15px'
                        }}
                      >
                        <Table.Summary.Cell index={0} colSpan={5}>
                         Rand per meter in damages
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={5} colSpan={1}>
                          {(totalMeters > 0
                            ? (totalDamageAmount) / totalMeters
                            : 0
                          ).toLocaleString('en-US', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          })}
                        </Table.Summary.Cell>
                      </Table.Summary.Row>
                    </Table.Summary>
                  )}
                >
                  <Column
                    title="Stock nr."
                    dataIndex="serial"
                    key="serial"
                    // width={200}
                  />
                  {window.innerWidth > 420 ? (
                    <Column
                      {...this.getColumnSearchProps('size')}
                      title="Tool Type"
                      dataIndex="size"
                      key="size"
                    />
                  ) : null}
                  <Column
                    title="Rig"
                    dataIndex="currentRig"
                    key="currentRig"
                    // width={"90%"}
                  />

                  <Column
                    {...this.getColumnSearchProps('reason')}
                    title="Reason"
                    dataIndex="reason"
                    key="reason"
                  />
                  {window.innerWidth > 420 ? (
                    <Column
                      {...this.getColumnSearchProps('date')}
                      title="Date"
                      dataIndex="date"
                      key="date"
                      render={text => {
                        const formattedDate = moment(text).format(
                          'YYYY-MM-DD HH:mm:ss'
                        );
                        return formattedDate;
                      }}
                    />
                  ) : null}
                  <Column
                    // title="Price"
                    title="Total"
                    dataIndex="prices"
                    key="prices"
                    // width={200}
                    render={text => {
                      return (
                        <span>
                          {parseFloat(text).toLocaleString('en-US', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          })}
                        </span>
                      );
                    }}
                  />
                </StyledTable>
              </Col>
            </Row>
            {/* )} */}
          </Spin>
        </div>
        {/* <Modal
          title="Add Stock"
          visible={this.state.addStockVisible}
          onOk={this.handleAddStock}
          onCancel={e => this.setState({ addStockVisible: false })}
          okText={this.state.editStock ? 'Save' : 'Add Stock'}
          cancelText="Cancel"
        >
          <StockForm
            editStock={this.state.editStock}
            wrappedComponentRef={form => (this.stockForm = form)}
          />
        </Modal> */}
        <Modal
          title={'Delete stock'}
          visible={this.state.deleteVisible}
          onOk={this.handleDeleteStock}
          onCancel={this.cancelDelete}
          okText="Accept"
          cancelText="Cancel"
        >
          <span>
            {' '}
            Are you sure you want to delete rig{' '}
            {this.props.stock.map(stock => (
              <span>{stock.currentRig}</span>
            ))}
          </span>
        </Modal>
        <Modal
          title={'Stock Out'}
          visible={this.state.outVisible}
          onOk={this.onEditStockOut}
          onCancel={e =>
            this.setState({ outVisible: false, qty: 1, qtyError: false })
          }
          okText="Submit"
          cancelText="Cancel"
        >
          <span>Qty</span>
          <InputNumber
            min={1}
            style={{ marginBottom: 15, width: '100%' }}
            onChange={this.checkQty}
            value={this.state.qty}
          />
          {this.state.qtyError ? (
            <p style={{ color: 'red', width: '100%' }}>
              There is not enough stock to satisfy this quantity
            </p>
          ) : null}
          <span>Requisition Number</span>
          <Input
            style={{ marginBottom: 15, width: '100%' }}
            value={this.state.requisitionNumber}
            onChange={e => this.setState({ requisitionNumber: e.target.value })}
          />
          <span>Assign stock to technician</span>
          <Select
            defaultActiveFirstOption={false}
            showArrow={false}
            filterOption={false}
            notFoundContent={null}
            showSearch
            style={{ width: '100%', marginBottom: 14 }}
            onSearch={this.handleSearchTechnician}
            value={this.state.userName}
            placeholder={'Type in at least 4 characters to start search'}
            onChange={e => this.setState({ userName: e })}
          >
            {technicianOptions}
          </Select>
          <span>Assign stock to job</span>
          <Select
            defaultActiveFirstOption={false}
            showArrow={false}
            filterOption={false}
            notFoundContent={null}
            showSearch
            style={{ width: '100%' }}
            onSearch={this.handleSearchJob}
            value={this.state.jobNumber}
            placeholder={'Type in at least 4 characters to start search'}
            onChange={e => this.setState({ jobNumber: e })}
          >
            {jobOptions}
          </Select>
        </Modal>
      </div>
    );
  }
}

export default Stock;
